export var EMPLOYEE_ROLE = /* @__PURE__ */ ((EMPLOYEE_ROLE2) => {
  EMPLOYEE_ROLE2["ENGINEER"] = "engineer";
  EMPLOYEE_ROLE2["SALES"] = "sales";
  EMPLOYEE_ROLE2["MARKETING"] = "marketing";
  EMPLOYEE_ROLE2["SUCCESS"] = "success";
  EMPLOYEE_ROLE2["SUPPORT_AGENT"] = "support_agent";
  return EMPLOYEE_ROLE2;
})(EMPLOYEE_ROLE || {});
export var EMPLOYEE_OWNERSHIP_AREA = /* @__PURE__ */ ((EMPLOYEE_OWNERSHIP_AREA2) => {
  EMPLOYEE_OWNERSHIP_AREA2["UX"] = "ux";
  EMPLOYEE_OWNERSHIP_AREA2["DESIGN"] = "design";
  EMPLOYEE_OWNERSHIP_AREA2["AI"] = "ai";
  EMPLOYEE_OWNERSHIP_AREA2["DEVOPS"] = "devops";
  EMPLOYEE_OWNERSHIP_AREA2["DATABASE"] = "database";
  EMPLOYEE_OWNERSHIP_AREA2["ANALYTICS"] = "analytics";
  EMPLOYEE_OWNERSHIP_AREA2["CACHING"] = "caching";
  EMPLOYEE_OWNERSHIP_AREA2["SCHEDULED_TASKS"] = "scheduled_tasks";
  EMPLOYEE_OWNERSHIP_AREA2["DEPLOYMENT"] = "deployment";
  EMPLOYEE_OWNERSHIP_AREA2["STORE_PLATFORMS"] = "store_platforms";
  EMPLOYEE_OWNERSHIP_AREA2["PAYMENT_PLATFORMS"] = "payment_platforms";
  EMPLOYEE_OWNERSHIP_AREA2["MARKETING_PLATFORMS"] = "marketing_platforms";
  EMPLOYEE_OWNERSHIP_AREA2["CLOUD_PLATFORMS"] = "cloud_platforms";
  EMPLOYEE_OWNERSHIP_AREA2["FLOW_ENGINE"] = "flow_engine";
  EMPLOYEE_OWNERSHIP_AREA2["FLOW_EDITOR"] = "flow_editor";
  EMPLOYEE_OWNERSHIP_AREA2["SEGMENTS"] = "segments";
  EMPLOYEE_OWNERSHIP_AREA2["POPUPS"] = "popups";
  EMPLOYEE_OWNERSHIP_AREA2["PAYMENTS"] = "payments";
  EMPLOYEE_OWNERSHIP_AREA2["CAMPAIGNS"] = "campaigns";
  EMPLOYEE_OWNERSHIP_AREA2["AUTOMATIONS"] = "automations";
  EMPLOYEE_OWNERSHIP_AREA2["BILLING"] = "billing";
  EMPLOYEE_OWNERSHIP_AREA2["MESSAGING"] = "messaging";
  EMPLOYEE_OWNERSHIP_AREA2["CHECKOUT"] = "checkout";
  EMPLOYEE_OWNERSHIP_AREA2["CUSTOMER_SUPPORT"] = "customer_support";
  EMPLOYEE_OWNERSHIP_AREA2["PERMISSIONS"] = "permissions";
  EMPLOYEE_OWNERSHIP_AREA2["RECOMMENDATIONS"] = "recommendations";
  EMPLOYEE_OWNERSHIP_AREA2["TRIGGERS"] = "triggers";
  EMPLOYEE_OWNERSHIP_AREA2["INTENTS"] = "intents";
  EMPLOYEE_OWNERSHIP_AREA2["SUBSCRIPTIONS"] = "subscriptions";
  EMPLOYEE_OWNERSHIP_AREA2["SLACK_BOT"] = "slack_bot";
  EMPLOYEE_OWNERSHIP_AREA2["GITHUB_BOT"] = "github_bot";
  return EMPLOYEE_OWNERSHIP_AREA2;
})(EMPLOYEE_OWNERSHIP_AREA || {});
